import { createRoot } from "react-dom/client";
import ReactModal from "react-modal";

import "./index.css";

import { AppLoader } from "./App";

const container = document.getElementById("root");
if (container) {
  ReactModal.setAppElement(container);
  const root = createRoot(container);
  // Apollo doesn't work well with StrictMode (leaking duplicated queries, fetching failed queries from unmounted components…).
  // Last check: @apollo/client@3.3.21
  root.render(<AppLoader />);
}
